import { createGetterBS, createSetterBS } from '@ocodelib/ex-util/rx';
import { BehaviorSubject } from 'rxjs';
import type { IAppConfig, IP5BasicLayoutConfig, P5BasicAppType } from './types';
import { UiState } from './UiState';

export class P5BasicAppManager {
  private app$ = new BehaviorSubject<P5BasicAppType | null>(null);

  readonly uiState = new UiState();

  constructor(readonly appConfig: IAppConfig) {
    // empty
  }

  setApp = createSetterBS(this.app$);
  observeApp = createGetterBS(this.app$);

  setup(config: IP5BasicLayoutConfig) {
    this.uiState.updateFromConfig(config);
    if (this.appConfig.previewMode) {
      this.uiState.setPreviewMode(true);
    }
  }
}
